import { object, string } from 'yup';

const profilePhotoSchema = object().shape({
  photoUpload: string().required('Please choose an image to upload.'),
});

export default profilePhotoSchema;
